import config from "../config";
import request from "./httpService";

const { backendBaseURL } = config().secrets;

const userKey = "admin";

export async function login(payload) {
	const url = `${backendBaseURL}/api/v1/admin/login`;
	const { data } = await request.post(url, payload);
	return data;
}

// export async function updateCredentials(username, password) {
// 	const url = `api/authenticateUpdate`;
// 	const payload = { username, password };
// 	const { data } = await request.post(url, payload);
// 	return data;
// }

export function getCurrentUser() {
	try {
		const user = localStorage.getItem(userKey);
		return JSON.parse(user);
	} catch (ex) {
		return {};
	}
}
